import { computed, ref, type MaybeRef, unref } from 'vue'

export function useHideDetails(
  props: { hideDetails?: boolean | 'auto' },
  errorMessage: MaybeRef<Set<string>>,
  hint: MaybeRef<string | undefined>
) {
  const _hideDetails = ref(false)

  function setHideDetails(value?: boolean) {
    if (typeof value === 'boolean') {
      _hideDetails.value = value
    }
  }

  const detailsIsVisible = computed(() => {
    if (props.hideDetails === 'auto') {
      return unref(errorMessage).size > 0 || unref(hint)
    }
    return _hideDetails.value
  })

  return {
    setHideDetails,
    detailsIsVisible
  }
}
